export default __webpack_public_path__ + "static/media/img_background_slide_six.e3ffc9df.png";